import styled, { css } from "styled-components";
import { Dropdown } from "react-bootstrap";
import { COLOR, APPEARANCE } from "../../../constants";

export const DropdownBlock = styled(Dropdown)`

  float: right;
  width: auto;
  min-width: 30px;
  min-height: 30px;
  height: 100%;
  position: relative;
  z-index: 10;
  i { padding: 2px; }
  button { 
    text-align: right!important; 
    padding: 0!important; 
    min-width: 30px;
    min-height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  button, a {
    background-color: var(--dropdown-primary)!important;
    color: var(--dropdown-primary-text)!important;
    cursor: pointer!important;
    :active, :focus { outline: none; box-shadow: none; }
    :hover { color: var(--dropdown-primary-text-hover)!important; }
  }
  
  ${props => (props.color === COLOR.LIGHT) && css`
    margin: 8px 0;
    width: auto;
    i {
      color: var(--white);
      margin: 0 0 0 15px!important;
      float: right;
    }
  `}
  
  ${props => (props.appearance === APPEARANCE.FILTER) && css`
    width: auto;
    float: initial;
    i {
      vertical-align: inherit;
      font-size: 26px;
      margin-left: 2px;
    }
  `}

  /* Melhorias para diferentes níveis de zoom */
  @media screen and (min-resolution: 1.5dppx) {
    min-width: 32px;
    min-height: 32px;
    button {
      min-width: 32px;
      min-height: 32px;
    }
  }
  
  @media screen and (min-resolution: 2dppx) {
    min-width: 34px;
    min-height: 34px;
    button {
      min-width: 34px;
      min-height: 34px;
    }
  }

`;
